import instantsearch from 'instantsearch.js';
import {
    clearRefinements,
    configure,
    currentRefinements,
    hits,
    pagination,
    refinementList,
    searchBox,
    stats,
    toggleRefinement,
} from 'instantsearch.js/es/widgets';

import { getAlgoliaSearchClient } from './algolia-helpers';

if (document.getElementById('search-results-box')) {
    const searchClient = getAlgoliaSearchClient();
    const indexName = `${window.algolia.prefix}_mckinnon`;
    const search = instantsearch({
        indexName,
        searchClient,
        searchFunction(helper) {
            if (helper.state.query) {
                document.getElementById('search-init').style.display = 'none';
            } else {
                document.getElementById('search-init').style.display = 'block';
            }

            helper.search();
        },
        searchParameters: {
            hitsPerPage: 18,
            filters: 'status:live OR status:enabled',
        },
        routing: true,
    });

    search.addWidgets([
        configure({
            analytics: true,
            clickAnalytics: true,
        }),

        clearRefinements({
            container: '#clear-refinements',
            templates: {
                resetLabel: 'Clear Filters',
            },
            cssClasses: {
                button: ['button', 'clear-filters'],
                disabledButton: ['hidden-button'],
            },
        }),

        clearRefinements({
            container: '#clear-refinements-second',
            templates: {
                resetLabel: 'Clear Filters',
            },
            cssClasses: {
                button: ['clear-filters', 'js-clear-filters'],
                disabledButton: ['hidden-button'],
            },
        }),

        currentRefinements({
            container: '#current-refined-values',
            transformItems(items) {
                return items.map(item => ({
                    ...item,
                    refinements: item.refinements.map(function(refinement) {
                        switch (refinement.attribute) {
                            case 'quickShip':
                                refinement.label = 'Quick Ship';
                                break;
                            case 'favorites':
                                refinement.label = 'Our Favorites';
                                break;
                            case 'new':
                                refinement.label = 'New';
                                break;
                            default:
                        }

                        return refinement;
                    }),
                }));
            },
        }),

        hits({
            container: '#search-hits',
            cssClasses: {
                item: ['result', 'cleared'],
            },
            templates: {
                item(hit) {
                    let template = `
                        <a
                            href="${hit.uri}"
                            onclick="if (!window.internalIPs.includes(window.userIP)) window.aa('clickedObjectIDsAfterSearch', {
                                index: '${indexName}',
                                eventName: 'Search Result Clicked',
                                objectIDs: ['${hit.objectID}'],
                                queryID: '${hit.__queryID}',
                                positions: [${hit.__position}],
                            });"
                        >
                            <figure>
                                <img src="data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=" srcset="${hit.image1x} 1x, ${hit.image2x} 2x" alt="" />
                            </figure>
                            <div class="text">
                                <div class="type">${hit.type}</div>
                    `;

                    if (hit.type === 'Furniture' || hit.type === 'Deck Blankets' || hit.type === 'Textiles') {
                        template += `
                                <h2>${instantsearch.highlight({ attribute: 'title', hit })}</h2>
                                <div class="desc">${hit.display_text}</div>
                                <p class="view">View Details <img src="/assets/images/icon-arrow-right.svg" width="7" height="11" alt=""></p>
                            </div><!-- /.text -->
                        </a>
                        `;
                    } else {
                        template += `
                                <h2>${instantsearch.highlight({ attribute: 'title', hit })}</h2>
                                <p class="desc">${instantsearch.snippet({ attribute: 'body', hit })}</p>
                                <p class="view">View Details <img src="/assets/images/icon-arrow-right.svg" width="7" height="11" alt=""></p>
                            </div><!-- /.text -->
                        </a>
                    `;
                    }

                    return template;
                },
            },
            transformItems(items) {
                return items.map(item => {
                    if (item.type === 'Textiles Variant') {
                        item._highlightResult.title.value = `${item.product_title}: ${item._highlightResult.title.value}`;
                        item.type = 'Textiles';
                    }
                    return item;
                });
            },
        }),

        pagination({
            container: '#pagination',
        }),

        refinementList({
            container: '#facet-categories',
            attribute: 'categories',
            limit: 100,
            templates: {
                item: `
                <div class="facet-item">
                    <a href="" class="facet-link toggle-refine facet-disjunctive">
                        <label>{{ label }}</label>
                    </a>
                </div><!-- /.facet-item -->
            `,
            },
        }),

        refinementList({
            container: '#facet-collection',
            attribute: 'collection',
            limit: 100,
            templates: {
                item: `
                <div class="facet-item">
                    <a href="" class="facet-link toggle-refine facet-disjunctive">
                        <label>{{ label }}</label>
                    </a>
                </div><!-- /.facet-item -->
            `,
            },
        }),

        searchBox({
            container: '#search-results-box',
            placeholder: 'Search',
            showReset: false,
            showSubmit: false,
        }),

        stats({
            container: '#search-stats',
            templates: {
                text: `
                <h1>
                    {{#query}}
                        {{#hasManyResults}}
                            {{#helpers.formatNumber}}{{nbHits}}{{/helpers.formatNumber}} results for "{{query}}"
                        {{/hasManyResults}}
                        {{#hasOneResult}}
                            {{#helpers.formatNumber}}{{nbHits}}{{/helpers.formatNumber}} result for "{{query}}"
                        {{/hasOneResult}}
                        {{#hasNoResults}}
                            No results found for "{{query}}"
                        {{/hasNoResults}}
                    {{/query}}
                </h1>
            `,
            },
        }),

        toggleRefinement({
            container: '#facet-quick-ship',
            attribute: 'quickShip',
            templates: {
                labelText: `Quick Ship`,
            },
        }),

        toggleRefinement({
            container: '#facet-favorites',
            attribute: 'favorites',
            templates: {
                labelText: `Our Favorites`,
            },
        }),

        toggleRefinement({
            container: '#facet-new',
            attribute: 'new',
            templates: {
                labelText: `New`,
            },
        }),
    ]);

    search.start();

    const hide = function() {
        document.getElementById('search-hits').style.display = 'none';
        document.getElementById('pagination').style.display = 'none';
        document.getElementById('search-stats-wrap').style.display = 'none';
        document.getElementById('search-filters').style.display = 'none';
        document.getElementById('search-intro-wrap').style.display = 'none';
    };

    const show = function() {
        document.getElementById('search-hits').style.display = 'block';
        document.getElementById('pagination').style.display = 'block';
        document.getElementById('search-stats-wrap').style.display = 'block';
        document.getElementById('search-filters').style.display = 'block';
        document.getElementById('search-intro-wrap').style.display = 'block';
    };

    const parent = document.getElementsByClassName('content cleared')[0];
    parent.getElementsByClassName('escape')[0].addEventListener('click', function() {
        search.helper.setQuery('');
        search.helper.clearRefinements().search();
        parent.getElementsByClassName('ais-SearchBox-input')[0].value = '';
        hide();
    });

    search.helper.on('result', function(data) {
        if (search.helper.state.query || Object.entries(search.helper.state.disjunctiveFacetsRefinements).length) {
            show();
        } else {
            hide();
        }

        if (data.nbHits < 18) {
            document.getElementById('pagination').style.display = 'none';
        } else {
            document.getElementById('pagination').style.display = 'block';
        }

        document.getElementById('facet-categories-header').style.display = 'none';
        document.getElementById('facet-collection-header').style.display = 'none';
        data.disjunctiveFacets.forEach(function(facet) {
            if (facet.name === 'categories') {
                document.getElementById('facet-categories-header').style.display = 'block';
            } else if (facet.name === 'collection') {
                document.getElementById('facet-collection-header').style.display = 'block';
            }
        });

        let showNew = false;
        let showFavorites = false;
        let showQuickShip = false;
        for (const key in search.helper.state.disjunctiveFacetsRefinements) {
            if (key === 'new') {
                document
                    .getElementById('facet-new')
                    .getElementsByTagName('span')[0]
                    .classList.add('active-facet');
                showNew = true;
            } else if (key === 'favorites') {
                document
                    .getElementById('facet-favorites')
                    .getElementsByTagName('span')[0]
                    .classList.add('active-facet');
                showFavorites = true;
            } else if (key === 'quickShip') {
                document
                    .getElementById('facet-quick-ship')
                    .getElementsByTagName('span')[0]
                    .classList.add('active-facet');
                showQuickShip = true;
            }
        }

        if (showNew === false) {
            document
                .getElementById('facet-new')
                .getElementsByTagName('span')[0]
                .classList.remove('active-facet');
        }

        if (showFavorites === false) {
            document
                .getElementById('facet-favorites')
                .getElementsByTagName('span')[0]
                .classList.remove('active-facet');
        }

        if (showQuickShip === false) {
            document
                .getElementById('facet-quick-ship')
                .getElementsByTagName('span')[0]
                .classList.remove('active-facet');
        }
    });
}
